import { SearchCheckIcon, ShieldAlertIcon } from "lucide-react";
import type { ReactNode } from "react";


/**
 * Ban and admin jail templates carry the anticheat flag, warn templates the
 * analyse one. Everything that differs between the two lives here so the
 * template pages can stay generic.
 */
export type TemplateFlagKind = 'anticheat' | 'analyse';

type TemplateFlagInfo = {
    label: string;
    badge: string;
    badgeLabel: string;
    badgeClass: string;
    badgeIcon: ReactNode;
    tooltipClass: string;
    permission: string;
    noPermHint: ReactNode;
};

export const templateFlags: Record<TemplateFlagKind, TemplateFlagInfo> = {
    anticheat: {
        label: 'Anticheat',
        badge: 'AC',
        badgeLabel: 'Anticheat sanction template',
        badgeClass: 'border-anticheat bg-anticheat-hint text-anticheat',
        badgeIcon: <ShieldAlertIcon className="size-4" />,
        tooltipClass: 'text-anticheat-inline',
        permission: 'players.anticheat',
        noPermHint: <>
            You need the "Anticheat Sanctions" permission<br />
            to flag a template as an anticheat sanction.
        </>,
    },
    analyse: {
        label: 'Analyse',
        badge: 'AN',
        badgeLabel: 'Analyse warn template',
        badgeClass: 'border-analyse bg-analyse-hint text-analyse',
        badgeIcon: <SearchCheckIcon className="size-4" />,
        tooltipClass: 'text-analyse-inline',
        permission: 'players.analyse',
        noPermHint: <>
            You need the "Analyse Warns" permission<br />
            to flag a template as an analyse warn.
        </>,
    },
};
